import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApsPermissionService } from './services/aps-permission/aps-permission.service';

@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	
	skipToMain: string;
	isAppReady = false;
	isAppLoading = true;
	
	constructor(
		private readonly router: Router,
		private readonly apsPermissionService: ApsPermissionService
	) {
	}
	
	async ngOnInit() {
		this.isAppReady = true;
		this.isAppLoading = false;

		if (window?.history && 'scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			takeUntilDestroyed(this.destroyRef)
		).subscribe((event: NavigationEnd) => {
			this.setSkipLinkUrl(event.urlAfterRedirects);
			this.scrollToTop();
		});
	}

	private setSkipLinkUrl(currentUrl: string) {
		if(!currentUrl.endsWith('#home-content')) {
			this.skipToMain = `${currentUrl}#home-content`;
		}
	}

	private scrollToTop() {
		setTimeout(() => {
			window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;

			const homeContent = document.getElementById('home-content');
			if (homeContent) {
				homeContent.scrollTop = 0;
			}

			const contentShell = document.querySelector('.app-content-shell') as HTMLElement | null;
			if (contentShell) {
				contentShell.scrollTop = 0;
			}

			const additionalScrollableContainers = document.querySelectorAll('.container, .container-body, .page-content, .p-dialog-content, .ui-dialog-content');
			additionalScrollableContainers.forEach((element) => {
				const htmlElement = element as HTMLElement;
				htmlElement.scrollTop = 0;
			});
		}, 0);
	}
}